<template>
  <div class="response_table">
    <table v-if="user_list.length > 0">
      <thead style="flex: 0">
      <tr>
        <th scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
          {{ translate("user.client") }}
        </th>
        <th scope="col">
          {{ translate("user.name") }}
        </th>
        <th scope="col" class="delete" />
      </tr>
      </thead>
      <tbody>

      <tr v-for="(user, index) in user_list" :key="index">
        <td :data-label="translate('user.client')" v-if="$store.getters.getPermissions.permissionGod === true">
          <router-link :to="{path: '/client/' + user.client_id}" class="link">
            <span v-html="user.client_name"/>
          </router-link>
        </td>

        <td :data-label="translate('user.name')">
          <router-link :to="{path: '/user/' + user.user_name}" class="link">
            <span v-html="user.name"/>
          </router-link>
        </td>

        <td class="delete" >
          <span
              v-if="list.created_by_user !== user.user_name"
              class="mdi mdi-close-box red"
              @click="confirm_delete(user)"
              title="delete"
          />
        </td>
      </tr>

      <tr>
        <div class="new_user__block">
          <div class="new_user" @click="add_user()">
            <span class="mdi mdi-plus-box" />
            <span class="title">
              {{ translate("custom.connect_user_to_list") }}
            </span>
          </div>
        </div>
      </tr>

      </tbody>
    </table>

    <div v-else style="height: 100%">
      <h5 style="text-align: center" >
        {{translate('no_data')}}
      </h5>
    </div>
  </div>
</template>
<script>

import AddToList from "./Modal/AddToList.vue";
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: "CustomUserList",
  props: ["list", "user_list"],
  data () {
    return {
      pwd: true,
      disabled_btn: false,
      old_url: '',
      user_roles: []
    }
  },
  computed:{

  },
  methods: {
    add_user() {
      let t = this.$createElement(AddToList, {
        props: {
          connected_users: this.user_list,
          list_id: this.list.id,
          type: "user"
        },
        on: {
          close: () => {
            this.$modal.hide('add_to_list')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'add_to_list'
      })
    },
    confirm_delete (user) {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('custom.ask_user_deleted')
        },
        on: {
          close: () => {
            this.$modal.hide('confirm_delete_custom_list')
          },
          confirm: () => {
            this.$emit("delete_user", user)
            this.$modal.hide('confirm_delete_custom_list')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'confirm_delete_custom_list'
      })
    },
  }
}

</script>
<style lang='scss' scoped>
.response_table{
  padding: 0;
}

.new_user {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 10px;
  padding: 10px;
  background: #41b8831f;
  border: 1px dashed #41b883;
  transition: 0.2s;
  margin-right: 10px;
  &:last-child{
    margin-right: 0;
  }
  .mdi {
    font-size: 25px;
  }
  &__block{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    background: #41b8835e;
  }
}
.delete{
  span{
    cursor: pointer;
  }
  .red{
    color: #EB5E28;
  }
}

</style>
